(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["life-balance-app"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  const VALID_SIDES = new Set(['yes', 'no']);
  const MAX_SCALE_ANGLE = 18;
  const EXAMPLE_BLOCKS = [
    { name: 'Loving Parents', weight: 200, side: 'yes' },
    { name: 'Toys', weight: 20, side: 'yes' },
    { name: 'School Life', weight: 20, side: 'yes' },
    { name: 'Friends', weight: 20, side: 'yes' },
    { name: 'Screentime', weight: 40, side: 'yes' },
    { name: 'Siblings', weight: 40, side: 'yes' },
    
  ];

  const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

  function makeId() {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    return `block-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  function createBlock(name, weight, side = 'yes', id = undefined) {
    const cleanName = String(name ?? '').trim();
    const numericWeight = Number(weight);
    const cleanSide = String(side ?? 'yes').trim().toLowerCase();

    if (!cleanName) throw new Error('Block name cannot be empty.');
    if (!Number.isFinite(numericWeight) || numericWeight < 0) {
      throw new Error('Weight must be a finite non-negative number.');
    }
    if (!VALID_SIDES.has(cleanSide)) throw new Error('Side must be yes or no.');

    return {
      id: typeof id === 'string' && id.trim() ? id : makeId(),
      name: cleanName,
      weight: numericWeight,
      side: cleanSide,
    };
  }

  function calculateBalance(blocks) {
    const yesWeight = blocks
      .filter((block) => block.side === 'yes')
      .reduce((sum, block) => sum + block.weight, 0);
    const noWeight = blocks
      .filter((block) => block.side === 'no')
      .reduce((sum, block) => sum + block.weight, 0);
    const totalWeight = yesWeight + noWeight;

    return {
      yesWeight,
      noWeight,
      totalWeight,
      balance: totalWeight === 0 ? 0 : clamp((yesWeight - noWeight) / totalWeight, -1, 1),
    };
  }

  const scaleAngle = (balance) => clamp(Number(balance) || 0, -1, 1) * MAX_SCALE_ANGLE;
  function mouthGeometry(balance) {
    const normalized = clamp(Number(balance) || 0, -1, 1);

    if (normalized >= 0) {
      return {
        endpointY: 158 - (8 * normalized),
        controlY: 158 + (34 * normalized),
      };
    }

    const intensity = Math.abs(normalized);
    return {
      endpointY: 158 + (12 * intensity),
      controlY: 158 - (26 * intensity),
    };
  }

  function parseActivity(value) {
    if (!Array.isArray(value)) throw new Error('The activity file must contain a list of blocks.');
    return value.map((item) => createBlock(item?.name, item?.weight, item?.side, item?.id));
  }

  function init(root) {
    if (!root || root.dataset.lifeBalanceInitialized === 'true') return;
    root.dataset.lifeBalanceInitialized = 'true';

    const sectionId = root.dataset.sectionId || 'default';
    const STORAGE_KEY = `life-balance-shopify-v1-${sectionId}`;
    const q = (selector) => root.querySelector(selector);

    const elements = {
      form: q('[data-role="block-form"]'),
      name: q('[data-role="block-name"]'),
      weight: q('[data-role="block-weight"]'),
      error: q('[data-role="form-error"]'),
      yesList: q('[data-role="yes-list"]'),
      noList: q('[data-role="no-list"]'),
      yesEmpty: q('[data-role="yes-empty"]'),
      noEmpty: q('[data-role="no-empty"]'),
      yesTotal: q('[data-role="yes-total"]'),
      noTotal: q('[data-role="no-total"]'),
      yesPanWeight: q('[data-role="yes-pan-weight"]'),
      noPanWeight: q('[data-role="no-pan-weight"]'),
      yesScaleBlocks: q('[data-role="yes-scale-blocks"]'),
      noScaleBlocks: q('[data-role="no-scale-blocks"]'),
      scaleBoard: q('[data-role="scale-board"]'),
      mouth: q('[data-role="mouth"]'),
      summary: q('[data-role="balance-summary"]'),
      detail: q('[data-role="balance-detail"]'),
      template: q('[data-role="block-template"]'),
      exampleButton: q('[data-action="load-example"]'),
      clearButton: q('[data-action="clear-all"]'),
      addButton: q('[data-action="add-block"]'),
    };

    function formatWeight(value) {
      return new Intl.NumberFormat(undefined, { maximumFractionDigits: 6 }).format(value);
    }

    function exampleBlocks() {
      return EXAMPLE_BLOCKS.map((block) => createBlock(block.name, block.weight, block.side));
    }

    function loadSavedActivity() {
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved ? parseActivity(JSON.parse(saved)) : exampleBlocks();
      } catch (error) {
        console.warn('Saved activity was invalid and has been replaced.', error);
        try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
        return exampleBlocks();
      }
    }

    let blocks = loadSavedActivity();

    function saveActivity() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(blocks));
      } catch (error) {
        console.warn('Browser saving is unavailable.', error);
      }
    }

    function replaceBlocks(nextBlocks) {
      blocks = nextBlocks;
      saveActivity();
      render();
    }

    function updateBlock(id, updates) {
      blocks = blocks.map((block) => block.id === id ? { ...block, ...updates } : block);
      saveActivity();
      render();
    }

    function deleteBlock(id) {
      blocks = blocks.filter((block) => block.id !== id);
      saveActivity();
      render();
    }

    function makeBlockElement(block) {
      const fragment = elements.template.content.cloneNode(true);
      const article = fragment.querySelector('.life-block');
      const name = fragment.querySelector('.block-name');
      const weight = fragment.querySelector('.block-weight');
      const moveButton = fragment.querySelector('.move-button');
      const deleteButton = fragment.querySelector('.delete-button');

      article.dataset.blockId = block.id;
      name.textContent = block.name;
      weight.textContent = `Weight: ${formatWeight(block.weight)}`;

      if (block.side === 'yes') {
        moveButton.textContent = "← Move to What I Don't Have";
        moveButton.setAttribute('aria-label', `Move ${block.name} to What I Don't Have`);
        moveButton.addEventListener('click', () => updateBlock(block.id, { side: 'no' }));
      } else {
        moveButton.textContent = "Move to What I Have →";
        moveButton.setAttribute('aria-label', `Move ${block.name} to What I Have`);
        moveButton.addEventListener('click', () => updateBlock(block.id, { side: 'yes' }));
      }

      deleteButton.setAttribute('aria-label', `Delete ${block.name}`);
      deleteButton.addEventListener('click', () => deleteBlock(block.id));
      return fragment;
    }

    function renderLists() {
      elements.yesList.replaceChildren();
      elements.noList.replaceChildren();
      const yesBlocks = blocks.filter((block) => block.side === 'yes');
      const noBlocks = blocks.filter((block) => block.side === 'no');
      yesBlocks.forEach((block) => elements.yesList.append(makeBlockElement(block)));
      noBlocks.forEach((block) => elements.noList.append(makeBlockElement(block)));
      elements.yesEmpty.hidden = yesBlocks.length > 0;
      elements.noEmpty.hidden = noBlocks.length > 0;
    }

    function makeScaleChip(block) {
      const chip = document.createElement('div');
      chip.className = `scale-chip ${block.side}-scale-chip`;
      chip.title = `${block.name} — weight ${formatWeight(block.weight)}`;

      const name = document.createElement('span');
      name.className = 'scale-chip-name';
      name.textContent = block.name;

      const weight = document.createElement('span');
      weight.className = 'scale-chip-weight';
      weight.textContent = formatWeight(block.weight);

      chip.append(name, weight);
      return chip;
    }

    function renderScaleSide(sideBlocks, container) {
      container.replaceChildren();
      container.classList.toggle('dense', sideBlocks.length > 4);
      const maximumVisible = 8;
      sideBlocks.slice(0, maximumVisible).forEach((block) => container.append(makeScaleChip(block)));
      if (sideBlocks.length > maximumVisible) {
        const overflow = document.createElement('div');
        overflow.className = 'scale-overflow';
        overflow.textContent = `+${sideBlocks.length - maximumVisible} more`;
        container.append(overflow);
      }
    }

    function renderScaleBlocks() {
      renderScaleSide(blocks.filter((block) => block.side === 'yes'), elements.yesScaleBlocks);
      renderScaleSide(blocks.filter((block) => block.side === 'no'), elements.noScaleBlocks);
    }

    function renderVisuals() {
      const result = calculateBalance(blocks);
      const yesText = formatWeight(result.yesWeight);
      const noText = formatWeight(result.noWeight);

      elements.yesTotal.textContent = yesText;
      elements.noTotal.textContent = noText;
      elements.yesPanWeight.textContent = yesText;
      elements.noPanWeight.textContent = noText;
      elements.scaleBoard.style.transform = `rotate(${scaleAngle(result.balance)}deg)`;
      const mouth = mouthGeometry(result.balance);
      elements.mouth.setAttribute('d', `M70 ${mouth.endpointY} Q120 ${mouth.controlY} 170 ${mouth.endpointY}`);

      if (result.totalWeight === 0) {
        elements.summary.textContent = 'Add blocks with a weight greater than zero to begin.';
        elements.detail.textContent = "What I Have: 0   What I Don't Have: 0";
        return;
      }

      const percentage = Math.abs(result.balance) * 100;
      const direction = result.balance > 0 ? 'WHAT I HAVE' : result.balance < 0 ? "WHAT I DON'T HAVE" : 'NEUTRAL';
      elements.summary.textContent = direction === 'NEUTRAL'
        ? 'The two sides are balanced.'
        : `${percentage.toFixed(1)}% toward ${direction}`;
      elements.detail.textContent = `What I Have: ${yesText}   What I Don't Have: ${noText}   Total: ${formatWeight(result.totalWeight)}`;
    }

    function render() {
      renderLists();
      renderScaleBlocks();
      renderVisuals();
    }

    function addBlock() {
      elements.error.textContent = '';
      try {
        blocks.push(createBlock(elements.name.value, elements.weight.value));
        saveActivity();
        render();
        elements.name.value = '';
        elements.weight.value = '';
        elements.name.focus();
      } catch (error) {
        elements.error.textContent = error.message;
      }
    }

    elements.addButton.addEventListener('click', addBlock);
    [elements.name, elements.weight].forEach((input) => {
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          addBlock();
        }
      });
    });

    elements.exampleButton.addEventListener('click', () => replaceBlocks(exampleBlocks()));
    elements.clearButton.addEventListener('click', () => {
      if (blocks.length === 0 || window.confirm('Clear all blocks?')) replaceBlocks([]);
    });

    render();
    saveActivity();
  }

  function initAll(scope = document) {
    if (scope.matches?.('[data-life-balance-app]')) init(scope);
    scope.querySelectorAll?.('[data-life-balance-app]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
